import { EntityType, Rights } from '@frontend/common';
import { useModals } from '@frontend/modal';
import { useAccountRepository } from '@frontend/repository';
import { useNavigate } from 'react-router-dom';

import { useAppDispatch } from '../../../redux/store';

export const useTemplates = () => {
    const { currentAccount } = useAccountRepository();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { openModal, closeModal } = useModals();
    const templateModalId = 'create-notification-template-modal';

    return {
        dispatch,
        navigate,
        openModal,
        closeModal,
        currentAccount,
        createTemplatePermissions: [{ item: EntityType.NOTIFICATION_TEMPLATE, source: EntityType.ACCOUNT, right: Rights.CREATE, uid: currentAccount }],
        templateModalId
    };
};
